import React from 'react';
import { useTranslation } from 'react-i18next';
import PriceSimulator from '../components/PriceSimulator';
import PageHeader from 'components/Common/PageHeader';
import { all_routes } from 'router/all_routes';

const PriceSimulatorPage: React.FC = () => {
  const { t } = useTranslation();

  const breadcrumbItems = [
    { label: 'dashboard', path: all_routes.superAdmin.dashboard },
    { label: 'priceSimulator.title', active: true },
  ];



  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t('priceSimulator.title')}
          breadcrumbItems={breadcrumbItems}
        />
        <div className="row">
          <div className="col-lg-12">
            <PriceSimulator />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceSimulatorPage;